export default "<div class=\"row\">\n  <div class=\"col-xs-12\" data-ui-view=\"main\"></div>\n</div>\n";